import * as React from 'react';

import './AvailabilitsDots.scss';

export enum Availability {
  green = 0,
  yellow = 1,
  red = 2
}

interface Props {
  active: Availability;
  hidden: boolean;
  className?: any;
  style?: any;
}

export const AvailabilityDots: React.SFC<Props> = ({ active, hidden, className, style }: Props) => (
  <div
    className={
      'avail_dots ' + (className !== undefined ? className : '') + (hidden ? ' hiddenBus' : '')
    }
    style={style}
  >
    <span className={'dot green' + (active === 0 ? ' active' : '')} />
    <span className={'dot yellow' + (active === 1 ? ' active' : '')} />
    <span className={'dot red' + (active === 2 ? ' active' : '')} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Week/Event/AvailabilityDots/AvailabilitsDots.tsx